import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import parseErrorResponse from './errorHandling';

const useLinkVerification = (token) => {
  const { t, i18n } = useTranslation();
  const [processing, setProcessing] = useState(false);

  const verifyLink = useCallback(async () => {
    try {
      setProcessing(true);
      const response = await axios.get(`/pay-by-link-service/api/v1/verify/${token}`, {
        params: { lang: i18n.language },
      });
      setProcessing(false);
      return response.data;
    } catch (err) {
      setProcessing(false);
      const error = parseErrorResponse(err);
      error.message = t(`error.${error.code}`) || t('error.unexpected');
      throw error;
    }
  }, [token]);

  return { verifyLink, processing };
};

export default useLinkVerification;
